export default __webpack_public_path__ + "static/media/ProjectsHeader.b6d2056f.jpg";